<script setup lang="ts">
/**
 * Marketing-site chrome: top nav + footer. Used by the homepage, every
 * vertical landing page, and /pricing.
 */
</script>

<template>
  <div class="min-h-screen flex flex-col bg-white text-gray-900">
    <MarketingNav />
    <main class="flex-1">
      <slot />
    </main>
    <MarketingFooter />
  </div>
</template>
